import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService, TaxesService, VendorsPriceListService, VendorsService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PoItemsRepository } from '../po-creation/repository/po-items.repository';
import { StockAdapter } from '../stock/dto/stock.adapter';
import { AsnAdapter } from './dto/asn.adapter';
import {  AsnItems } from './asn-items.entity';
import { AsnController } from './asn.controller';
import { Asn } from './asn.entity';
import { AsnService } from './asn.service';
import { AsnRepository } from './repository/asn-repository';
import { PoCreationModule } from '../po-creation/po-creation.module';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { ScheduleModule } from '@nestjs/schedule';
import { PoCreation } from '../po-creation/po-creation.entity';
import { Grn } from '../grn/grn.entity';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';


@Module({
  imports: [
    
    TypeOrmModule.forFeature([Asn,AsnItems,AsnRepository,PoItemsRepository,PoCreation,Grn]),
    PoCreationModule,
    ScheduleModule.forRoot(),
    
  ],
  controllers: [AsnController],
  providers: [AsnService,ApplicationExceptionHandler,AsnAdapter,WhatsAppNotificationService,WhatsappBroadCastService]
})
export class AsnModule {}
